import React, { useState } from "react";
import Carousel from "./Carousel";
import {
  EnvelopeIcon,
  LockClosedIcon,
  UserIcon,
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { registerService } from "../../api/services/authServices";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.termsAccepted === false) {
      return toast.error("Please accept the terms and conditions to continue");
    }
    if (formData.password !== formData.confirmPassword) {
      return toast.error("Passwords do not match!");
    }

    let user = {
      fullName: formData.name,
      email: formData.email,
      password: formData.password,
    }
    let response = await registerService(user);
    if (response.status === 201) {
      toast.success("Email sent to verify your account");
      navigate("/validate-otp", { state: { userId: response.data.userId } });
    } else {
      toast.error("Something went wrong");
    }
    console.log(response);
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-[30%] hidden md:block">
        <Carousel />
      </div>

      <div className="w-full md:w-[70%] flex items-center justify-center px-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white w-full max-w-lg p-8 rounded-[15px] [box-shadow:0px_2px_8px_0px_#80808040] space-y-6"
        >
          <h2 className="text-2xl font-semibold text-center">Sign Up</h2>

          {/* Full Name */}
          <div className="border border-gray-300 rounded-lg flex items-center pr-3">
            <UserIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
              required
            />
          </div>

          {/* Email */}
          <div className="border border-gray-300 rounded-lg flex items-center pr-3">
            <EnvelopeIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
              required
            />
          </div>

          <div className="border border-gray-300 rounded-lg flex items-center pr-3">
            <LockClosedIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="ml-2 text-gray-500 hover:text-gray-700"
            >
              {showPassword ? (
                <EyeSlashIcon className="w-5 h-5 text-[#56B22F]" />
              ) : (
                <EyeIcon className="w-5 h-5 text-[#56B22F]" />
              )}
            </button>
          </div>

          <div className="border border-gray-300 rounded-lg flex items-center pr-3">
            <LockClosedIcon className="w-6 h-6 ml-2 text-[#56B22F]" />
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full px-2 py-3 focus:ring-2 focus:ring-transparent focus:border-transparent outline-none"
              required
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
              className="ml-2 text-gray-500 hover:text-gray-700"
            >
              {showConfirmPassword ? (
                <EyeSlashIcon className="w-5 h-5 text-[#56B22F]" />
              ) : (
                <EyeIcon className="w-5 h-5 text-[#56B22F]" />
              )}
            </button>
          </div>

          {/* Terms and Conditions */}
          <div className="flex items-center text-sm text-gray-600">
            <input
              type="checkbox"
              name="termsAccepted"
              checked={formData.termsAccepted}
              onChange={handleChange}
              required
            />
            <span className="ml-2">
              By Sign Up, You Agree to The Terms of Services & Privacy Policy
            </span>
          </div>

          <button
            type="submit"
            className="w-full bg-[#56B22F] text-white py-3 rounded-lg font-semibold hover:bg-[#4a9c28] transition-colors"
          >
            Sign Up
          </button>
          <p className="text-center text-sm text-gray-600">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/sign-in")}
              className="text-[#56B22F] font-medium cursor-pointer"
            >
              Sign In here
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
